<mat-card [ngClass]="class">
  <div class="flashable-item">
    <mat-card-header>
      <mat-card-title *ngIf="title != ''"
        ><span
          [class.header-medium-title]="headerSize == 'medium'"
          [class.header-small-title]="headerSize == 'small'"
          >{{ title }}</span
        >
      </mat-card-title>
      <mat-card-subtitle *ngIf="subtitle != ''">
        {{ subtitle }}
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <ng-content />
    </mat-card-content>
  </div>
</mat-card>
